import { filter } from 'rxjs/operators';

import { ChangeDetectionStrategy, Component, HostListener, OnDestroy } from '@angular/core';
import { VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizDatasource,
} from '@wizeoo/akm-component-lib';
import { Subscription } from 'rxjs';
import { VisionKey, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';

import { WidgetDataPopDatas } from '../../../manager/widgets/i-widget';
import { GridsterWidget } from '../../../vo/workingzone/gridster-widget';
import { Model } from '../../../model/model';
import { VisionStepVO } from '../../../vo/vision/visionstep.vo';
import { ViewData } from '../../../model/view.data';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { MultiDisplayConfig } from '../../multi-display/config/multi-display.config';
/**
 * Pop de sélection du périmètre de données du widget (Vision, vision step, step perimeter)
 */
@Component({
  selector: 'generator-data-pop',
  templateUrl: './generator-data.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneratorDataPop extends WizBasePopUp implements OnDestroy {
  
    // validation sur enter, sortie sur Esc
    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
      if (event.key === VALUE_ENTER && this.validable) {
        this.save();
      }
      if (event.key === VALUE_ESCAPE) {
        this.hide();
      }
    }
  
  // dimensions demandées
  public static width: string = '520px';
  public static height: string = '550px';
  

  
  /** La datasource de choix de visionStep (de la vision) */
  stepDS: WizDatasource<VisionStepVO> = new WizDatasource<VisionStepVO>()
    .setSortFields([{ property: 'level', way: 'asc', numeric: true }])
    .build();

  /** tous les widgets éligibles comme 'Master' */
  public allAgis: WizDatasource<GridsterWidget> = new WizDatasource<GridsterWidget>([])
    .setItemCodeField('uid')
    .setSortFields([{ property: 'indice', way: 'asc', numeric: true }])
    .setSelectionMode('multiple')
    .build();

  /**
   * configuration de la liste de steps
   */
  public masterConfig: MultiDisplayConfig<GridsterWidget> = {
      model: this.model,
      datasource: this.allAgis,
      defaultMode: 'grid',
      grid: {
        rowSelection: 'multiple',
        enabled: true,
        columns: [
          { headerName: '$.common.widget.$', field: 'labelAndIdx', flex: 1 },

        ],
        suppressRowClickSelection: true,
      },
  };
  





  public currentMasters: Map<string, GridsterWidget> = new Map(); // le maître en cours de sélection

  private _subs: Subscription[] = []; // listener pour garantir l'unicité de sélection


  public show(): void {
    this.feedSteps(); // alimentation des steps (1x)
    this.feedMasterDS(); // alimentation de la drop des maîtres (chaque changement de step)

    this.setListeners();
  }

  /** pose des écouteurs  */
  private setListeners(): void {
    this._subs.push(
      this.stepDS.changes.pipe(filter((c) => c.type === 'selectionChanged')).subscribe((c) => {
        this.feedMasterDS(); // alimentation de la drop des maîtres (chaque changement de step)
      })
    );

  }

  ngOnDestroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
  }

  public datas: WidgetDataPopDatas;

  public get model(): Model {
    return this.datas?.model as Model || null;
  }

  /** accesseur sur le data avec le bon type */
  private get wco(): WidgetConfigurationObj {
    return this.datas.config;
  }

  public get validable(): boolean {
    return !!this.stepDS.selectedItem;
  }

  /**
   * génération de la collection de step pour alimentation de la drop
   * et alimentation du grid si le contexte est alimenté
   */
  private feedSteps(): void {
    let stepArr: VisionStepVO[] = [];
    // le data est un widgetC
    const visionCode = this.wco.v;
    const vision =  this.model.visionEngine.getVision(visionCode);
    if (!!vision && !!vision.visionSteps) {
      stepArr = Object.values(vision.visionSteps).map((visionStep) => new VisionStepVO(visionStep));
    }
    this.stepDS.itemCodeField = 'visionAndStep';
    this.stepDS.setSource(stepArr);

    if (this.wco.vs) {
      // visionStep défini
      const selectedVS: VisionStepVO = stepArr.find((vs) => vs.level === Number(this.wco.vs));
      if (!!selectedVS) {
        this.stepDS.select([selectedVS]);
      }
    }

    if (this.wco.muid) {
      // maître alimenté
      let splitted: string[] = this.wco.muid.split(ViewData.KEY_SEPARATOR);
      this.currentMasters = new Map();
      splitted.forEach(s => {
        this.currentMasters.set(s, this.model.widgetEngine.getWidgetByUid(s));
      });
    }

  }

  /** alimentation de la DS des maîtres possibles */
  private feedMasterDS(): void {
    // console.log('feed master todo chopper tous les FDGrid >=')
    
    if(!this.stepDS.selectedItem) { // pas de step, sortie à vide
      this.allAgis.setSource([]);
      return;
    }



    let all: GridsterWidget[] = this.model.workingTemplateClone.widgets; // tous les widgets du template
    
    // je prends mon step pour déterminer mes clés
    // je balaie tous les widgets de type FDGrid qui possèdent une clé comme la mienne, level <=

    let vs: VisionStepVO = this.stepDS.selectedItem;

    let v: VisionVO = this.model.visionEngine.getVision(vs.visionCode);

    let keyMap: Map<string, number> = new Map();// la map de mes clés de step, juste le code du FD, = mon levelmax

    Object.values(v.visionKeys).forEach((vk: VisionKey) => {
      if(vk.stepLevel <= vs.level) {
        let key: string = vk.code.split(ViewData.CONTEXT_SEPARATOR)[0];
        keyMap.set(key, vk.level); // de toute façon on est dans l'ordre, donc j'aurai le plus gros niveau de profondeur
      }
    });
 
    // console.log('feed master : ', keyMap);
    
    let availableMasters: GridsterWidget[] = [];
    let me: GridsterWidget = this.datas.gridsterConfig;
    all.forEach(m => {
      // console.log('gw : ', m);

      if(keyMap.has(m.freedataCode) && m.freedataLevel <= keyMap.get(m.freedataCode)) {
        availableMasters.push(m);
      }
    });
    this.allAgis.setSource([...availableMasters]);

    let selected: GridsterWidget[] = [];

    this.allAgis.getSource().forEach(gw => {
      if(this.currentMasters.has(gw.uid)) {
        selected.push(gw);
      }
    });
    this.allAgis.select(selected);


  }


  /** sur save, alimentation de l'objet de configuration */
  public save(): void {
    let stepChanged: boolean = false;
    const previousLevel: number = Number(this.wco.vs);

    this.wco.vs = this.stepDS.selectedItem ? this.stepDS.selectedItem.level : null;
    
    this.wco.muid = null;
    
    if(this.allAgis.selectedItems?.length > 0) {
      let parts: string[] = [];
      this.allAgis.selectedItems?.forEach(gw => {
        parts.push(gw.uid);
      });
      this.wco.muid = parts.join(ViewData.KEY_SEPARATOR);
    }

    if (previousLevel !== Number(this.wco.vs)) {
      stepChanged = true;
    }

    this.callback(this.wco, stepChanged);
    this.hide();
  }



}
